import React from 'react'
// import DialogInputLabel from './DialogInputLabel'
import FormGroup from '@tencent/spaui-formgroup'
import Input from '@tencent/spaui-input'
import { Button } from '@tencent/spaui'

const PopChannelNameForm = ({
    value = '',
    error,
    onChange,
    onCancel,
    onSubmit,
    _style,
    inputStyle,
    buttonStyle,
    helpBlock,
    status,
}) => {
    const feedback = (
        <span>
            <span className="spaui-input-feedback-count">{value.length}</span>
            <span className="spaui-input-feedback-divider">/</span>
            <span className="spaui-input-feedback-range">128</span>
        </span>
    )

    return (
        <div className="track-body-item" style={_style}>
            <div style={{ textIndent: '10px', paddingTop: '10px' }}>修改渠道包名称</div>
            <FormGroup error={error} style={inputStyle} feedback={feedback} helpBlock={helpBlock} status={status}>
                <Input
                    value={value}
                    placeholder="请输入渠道包名称"
                    maxLength="128"
                    onChange={(e, val) => onChange(val)}
                />
            </FormGroup>
            <div style={buttonStyle}>
                <Button size="small" style={{ margin: '5px' }} onClick={e => onCancel()}>
                    {' '}
                    取消{' '}
                </Button>
                <Button size="small" displayType="primary" style={{ margin: '5px' }} onClick={e => onSubmit()}>
                    确定
                </Button>
            </div>
        </div>
    )
}

export default PopChannelNameForm
